import {config} from "./config";
import {fetchWrapper} from "../_services/fetch";

export const endpoints = {
    user: {
        vat: (userId) => config.get_remote_api() + "/api/accounts/vat/" + userId,
    },

    cart: {
        get: () => config.get_remote_api() + "/api/basket/get",
        add: () => config.get_remote_api() + "/api/basket/add",
        edit: () => config.get_remote_api() + "/api/basket/edit",
        submit: () => config.get_remote_api() + "/api/basket/submit",
        count: () => config.get_remote_api() + "/api/basket/count"
    },

    address: {
        order: () => config.get_remote_api() + "/api/addresses/order",
        get: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        count: (userId, search) => config.get_remote_api() + "/api/addresses/count/" + userId + fetchWrapper.getSearchParams(search),
        list: (userId, search) => config.get_remote_api() + "/api/addresses/list/" + userId + fetchWrapper.getSearchParams(search),
        add: (userId) => config.get_remote_api() + "/api/addresses/" + userId,
        edit: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        delete: (userId, targetId) => config.get_remote_api() + "/api/addresses/" + userId + "/" + targetId,
        deletes: (userId) => config.get_remote_api() + "/api/addresses/delete/" + userId,
    },

    carrier: {
        order: () => config.get_remote_api() + "/api/carriers/order",
        get: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
        count: (search) => config.get_remote_api() + "/api/carriers/count" + fetchWrapper.getSearchParams(search),
        list: (search) => config.get_remote_api() + "/api/carriers/list" + fetchWrapper.getSearchParams(search),
        add: () => config.get_remote_api() + "/api/carriers/add",
        edit: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
        delete: (targetId) => config.get_remote_api() + "/api/carriers/" + targetId,
    },

    country: {
        order: () => config.get_remote_api() + "/api/countries/order",
    },

    payment: {
        get: (targetId) => config.get_remote_api() + "/api/payment/" + targetId,
        list: (search) => config.get_remote_api() + "/api/payment/list" + fetchWrapper.getSearchParams(search),
    },

    paypal: {
        create: () => config.get_remote_api() + "/api/paypal/create",
        capture: (orderId) => `${config.get_remote_api()}/api/paypal/capture/${orderId}`
    },

    order: {
        status: () => config.get_remote_api() + "/api/order/status-options",
        order: () => config.get_remote_api() + "/api/order/order",
    },

    device: {
        get: (userId, deviceId) => config.get_remote_api() + "/api/devices/get/" + userId + "/" + deviceId,
        add: (userId) => config.get_remote_api() + "/api/devices/add/" + userId,
        edit: (userId, deviceId) => config.get_remote_api() + "/api/devices/edit/" + userId + "/" + deviceId,
        delete: (userId, deviceId) => config.get_remote_api() + "/api/devices/delete/" + userId + "/" + deviceId,
        list: (userId, deviceClass) => config.get_remote_api() + "/api/devices/list/" + userId + "/" + deviceClass,
        listFilter: (userId) => config.get_remote_api() + "/api/devices/list/" + userId,
        count: (userId, deviceClass) => config.get_remote_api() + "/api/devices/count/" + userId + "/" + deviceClass,
        countFilter: (userId) => config.get_remote_api() + "/api/devices/count/" + userId,
        query: (serial) => config.get_remote_api() + "/api/devices/query?serial=" + serial,
        orderOptions: () => config.get_remote_api() + "/api/devices/order",
    },

    icon: {
        get: (iconId) => iconId ? config.get_remote_api() + "/api/icons/" + iconId : null,
        list: (userId) => config.get_remote_api() + "/api/icons/list/" + userId,
    },

    automation: {
        get: (userId, automationId) => config.get_remote_api() + "/api/automations/" + userId + "/" + automationId,
        add: (userId) => config.get_remote_api() + "/api/automations/" + userId,
        count: (userId, search) => config.get_remote_api() + "/api/automations/count/" + userId + fetchWrapper.getSearchParams(search),
        list: (userId) => config.get_remote_api() + "/api/automations/list/" + userId,
        edit: (targetId, automationId) => config.get_remote_api() + "/api/automations/edit/" + targetId + "/" + automationId,
    },

    event: {
        get: (eventId) => config.get_remote_api() + "/api/events/get/" + eventId,
        add: (deviceId) => config.get_remote_api() + "/api/events/add/" + deviceId,
        edit: (eventId) => config.get_remote_api() + "/api/events/edit/" + eventId,
        count: (deviceId) => config.get_remote_api() + "/api/events/count/" + deviceId,
        list: (deviceId) => config.get_remote_api() + "/api/events/list/" + deviceId,
        del: (eventId) => config.get_remote_api() + "/api/events/delete/" + eventId,
    },

    push: {
        // EventSource (SSE) does not natively support custom headers to add Bearer, so use search param to send auth token (JWT)
        all_devs: (userId, jwt) => config.get_remote_api() + "/api/push/" + userId + "/all_devs?token=" + jwt,
        device: (userId, deviceId, jwt, fields) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/get?token=" + jwt + "&fields=" + fields.join("_"),
        action: (userId, deviceId) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/action",
        relay: (userId, deviceId) => config.get_remote_api() + "/api/push/" + userId + "/" + deviceId + "/relay",
    }
}